import SuperTokens from 'supertokens-web-js';
import Session from 'supertokens-web-js/recipe/session';
import EmailPassword from 'supertokens-web-js/recipe/emailpassword';
import ThirdParty from 'supertokens-web-js/recipe/thirdparty';
import { hosts } from '@/config/api.routes';

let initialized = false;

export const isSuperTokensAuth = () => !!process.env.FEATURE_FLAGS.SUPERTOKENS_AUTH;

export const isSuperTokensSso = () => (
  isSuperTokensAuth() && !!process.env.SUPERTOKENS_SSO?.enabled
);

function getManagementApiInfo() {
  const managementUrl = new URL(hosts.management);
  const basePrefix = managementUrl.pathname.replace(/\/$/, '');

  return {
    apiDomain: managementUrl.origin,
    apiBasePath: `${basePrefix}/auth`.replace(/\/+/g, '/'),
  };
}

export function initSuperTokens() {
  if (initialized || !isSuperTokensAuth()) {
    return;
  }

  const recipeList = [
    Session.init({ tokenTransferMethod: 'header', autoAddCredentials: false }),
    EmailPassword.init(),
  ];

  if (isSuperTokensSso()) {
    recipeList.push(ThirdParty.init());
  }

  const { apiDomain, apiBasePath } = getManagementApiInfo();

  SuperTokens.init({
    appInfo: {
      appName: 'AgentIQ',
      apiDomain,
      apiBasePath,
    },
    recipeList,
  });

  initialized = true;
}

export { Session, EmailPassword, ThirdParty };
